var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1563 34.775C22.5333 35.3979 21.7615 35.7094 20.8406 35.7094C19.9198 35.7094 19.1479 35.3979 18.525 34.775L4.22501 20.475C3.92709 20.1771 3.68984 19.825 3.51326 19.4187C3.33668 19.0125 3.24893 18.5792 3.25001 18.1187V6.5C3.25001 5.60625 3.56851 4.84087 4.20551 4.20387C4.84251 3.56687 5.60734 3.24892 6.50001 3.25H18.1188C18.5792 3.25 19.0125 3.33829 19.4188 3.51487C19.825 3.69146 20.1771 3.92817 20.475 4.225L34.775 18.5656C35.3979 19.1885 35.7094 19.9539 35.7094 20.8617C35.7094 21.7696 35.3979 22.5344 34.775 23.1562L23.1563 34.775ZM20.8406 32.5L32.4594 20.8812L18.1188 6.5H6.50001V18.1187L20.8406 32.5ZM10.5625 13C11.2396 13 11.8154 12.7627 12.2899 12.2882C12.7644 11.8137 13.0011 11.2385 13 10.5625C13 9.88542 12.7628 9.30962 12.2883 8.83512C11.8138 8.36062 11.2385 8.12392 10.5625 8.125C9.88543 8.125 9.30963 8.36225 8.83513 8.83675C8.36063 9.31125 8.12393 9.8865 8.12501 10.5625C8.12501 11.2396 8.36226 11.8154 8.83676 12.2899C9.31126 12.7644 9.88651 13.0011 10.5625 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.3aca4642f69f410a715af8b921b5b9c8.svg";
export { ForwardRef as ReactComponent };